module.exports = __webpack_public_path__ + "static/img/bg2.e178620a.jpg";